module.exports = __webpack_public_path__ + "media/images/logo-text-af8af694c9fcb5da697ea3fbdd1d3169.png";